import {
  AUDIT_LOGS_CHANGE_CURRENT_PAGE ,
AUDIT_LOGS_CHANGE_ROWS_PER_PAGE ,
ADMIN_GET_FILTER_AUDIT_LOGS_REQUEST ,
ADMIN_GET_FILTER_AUDIT_LOGS_SUCCESS ,
ADMIN_GET_FILTER_AUDIT_LOGS_ERROR ,
GET_BY_ID_AUDIT_LOGS_REQUEST ,
GET_BY_ID_AUDIT_LOGS_SUCCESS ,
GET_BY_ID_AUDIT_LOGS_ERROR ,
SET_AUDIT_LOGS ,
SET_AUDIT_LOGS_FILTER_VALUE ,
AUDIT_LOGS_GET_BY_FACTORY_ID_REQUEST ,
AUDIT_LOGS_GET_BY_FACTORY_ID_SUCCESS ,
AUDIT_LOGS_GET_BY_FACTORY_ID_ERROR ,
} from './types'
import axios from "axios";
import { api, createHeaders } from "../constants/api-urls";



export const changeCurrentPage = (page) => ({
  type:AUDIT_LOGS_CHANGE_CURRENT_PAGE,
  payload: page,
});

export const changeRowsPerPage = (count) => ({
  type:AUDIT_LOGS_CHANGE_ROWS_PER_PAGE, 
  payload: count,
});


const getByFilterAuditLogsSuccess = (value) => ({
  type:ADMIN_GET_FILTER_AUDIT_LOGS_SUCCESS,
  payload: value,
});

const getByFilterAuditLogsFilter= () => ({
  type:ADMIN_GET_FILTER_AUDIT_LOGS_REQUEST,
});



const getByFilterAuditLogsFailure = (error) => ({
  type:ADMIN_GET_FILTER_AUDIT_LOGS_ERROR,
  payload: {
    error,
  },
});

export const getByFilterAuditLogs = (
  limit = 20,
  page = 0,
  sort = -1,
  factory_id,
  search
) => {
  return (dispatch) => {
    dispatch(getByFilterAuditLogsFilter());
    let filter = `limit=${limit}&page=${page}&sort=${sort}
    ${factory_id ? `&factory_id=${factory_id}` : ``}
    ${search ? `&search=${search}` : ''}`;

    let url = `${api.admin.auditLogs.getByFilter(filter)}`;
    const headers = createHeaders();
    console.log({url})
    axios
      .get(url, { headers })
      .then((res) => {
        const { ok, result, count } = res.data;
        dispatch(getByFilterAuditLogsSuccess({ result: result, count: count }));
      })
      .catch((err) => {
        dispatch(getByFilterAuditLogsFailure(err.message));
      });
  };
};



const getAuditLogsRequest = () => ({
  type:GET_BY_ID_AUDIT_LOGS_REQUEST,
});

const getAuditLogsSuccess = (log) => ({
  type:GET_BY_ID_AUDIT_LOGS_SUCCESS,
  payload: log,
});


const getAuditLogsFailure = (error) => ({
  type:GET_BY_ID_AUDIT_LOGS_ERROR,
  payload: {
    error,
  },
});

export const getByAuditLogById = (id) => {
  return (dispatch) => {
    dispatch(getAuditLogsRequest());
    let url = `${api.admin.auditLogs.getById(id)}`;
    const headers = createHeaders();
    axios
      .get(url, { headers })
      .then((res) => {
        dispatch(getAuditLogsSuccess(res.data));   
      })
      .catch((err) => {
        dispatch(getAuditLogsFailure(err.message));
      });
  };
};

export const setAuditLogsDetais = (factory) => {
  return {
    type:SET_AUDIT_LOGS,
    payload: factory,
  };
};

export const setAuditLogsFilterValue = (value) => { 
  return (dispatch) => {
    dispatch ({
      type:SET_AUDIT_LOGS_FILTER_VALUE,
      payload: value ,
      });
  }
}




const getLogByFactoryRequest = () => ({
  type:AUDIT_LOGS_GET_BY_FACTORY_ID_REQUEST,
});

export const getLogByFactorySuccess = (subAuditLogss) => ({
  type:AUDIT_LOGS_GET_BY_FACTORY_ID_SUCCESS,
  payload: subAuditLogss,
});

const getLogByFactoryFailure = (error) => ({
  type:AUDIT_LOGS_GET_BY_FACTORY_ID_ERROR,
  payload: {
    error,
  },
});

export const getLogByFactory = (factory_id) => {
  return (dispatch) => {
    dispatch(getLogByFactoryRequest());
    let url = `${api.admin.auditLogs.getByFactoryId(factory_id)}`;
    const headers = createHeaders();
    axios
      .get(url, { headers })
      .then((res) => {
        const { ok, result } = res.data;
        dispatch(getLogByFactorySuccess(result));
      })
      .catch((err) => {
        dispatch(getLogByFactoryFailure(err.message));
      }); 
  };
};
